import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "foreign-trade" }
const _hoisted_2 = { class: "foreign-trade__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AnalyticsNotesForeignTradeTextMonthly = _resolveComponent("AnalyticsNotesForeignTradeTextMonthly")!
  const _component_AnalyticsNotesForeignTradeTextYearly = _resolveComponent("AnalyticsNotesForeignTradeTextYearly")!
  const _component_AnalyticsNotesForeignTradeTable = _resolveComponent("AnalyticsNotesForeignTradeTable")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "title title--h2 foreign-trade__title" }, "Внешняя торговля", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isMonthly)
        ? (_openBlock(), _createBlock(_component_AnalyticsNotesForeignTradeTextMonthly, {
            key: 0,
            filter: _ctx.filter
          }, null, 8, ["filter"]))
        : (_openBlock(), _createBlock(_component_AnalyticsNotesForeignTradeTextYearly, {
            key: 1,
            filter: _ctx.filter
          }, null, 8, ["filter"])),
      _createVNode(_component_AnalyticsNotesForeignTradeTable, {
        filter: _ctx.filter,
        isMonthly: _ctx.isMonthly
      }, null, 8, ["filter", "isMonthly"])
    ])
  ]))
}